import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=3c7168fa&"
import script from "./SearchCustomer.vue?vue&type=script&lang=js&"
export * from "./SearchCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SearchCustomer.vue?vue&type=style&index=0&id=3c7168fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports